// Recovered compiled webpack factory 92385. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "getRouteMatcher", {
      enumerable: !0,
      get: function () {
        return o;
      },
    }));
  let n = r(62296),
    a = r(34738);
  function o(e) {
    let { re: t, groups: r } = e;
    return (0, a.safeRouteMatcher)((e) => {
      let a = t.exec(e);
      if (!a) return !1;
      let o = (e) => {
          try {
            return decodeURIComponent(e);
          } catch (e) {
            throw Object.defineProperty(
              new n.DecodeError("failed to decode param"),
              "__NEXT_ERROR_CODE",
              { value: "E528", enumerable: !1, configurable: !0 },
            );
          }
        },
        i = {};
      for (let [e, t] of Object.entries(r)) {
        let r = a[t.pos];
        void 0 !== r && (t.repeat ? (i[e] = r.split("/").map((e) => o(e))) : (i[e] = o(r)));
      }
      return i;
    });
  }
}
